import styled from 'styled-components';

export const LogoImg = styled.img`
  max-width: 300px;
  max-height: 300px;
`;
